// extracted by mini-css-extract-plugin
module.exports = {"roundButton":"_2dTRn5","icon":"_3r2Y7O"};